import { ListGroup } from '../../../share/Components'

const RecordSummary = ({ data }) => {
  return (
    <>
      <div className='p-3'>
        {
          <ListGroup
            title=''
            items={data?.items?.filter(
              (item) => item.items && item.items.length > 0
            )}
          />
        }
      </div>
    </>
  )
}

export default RecordSummary
